import React from 'react'
import { TabPane } from "reactstrap";
import moment from "moment";
import { formatToSystemTimezone, getBackgroundColor } from '../../../../Components/Common/ToCamelCase';
import { formatDuration } from '../../../../Components/Common/FlatePicker';
import { CommanDataTables, LeadDataTable } from '../../../../Components/Common/DashboardDataTbale';
import { Link } from 'react-router-dom';



const ReportTabPane = ({ tabId, columns, data, totalRows, pagination, onPageChange, onPerRowsChange, isLoading, customActiveTab }) => {
    // For tab "5", use CommanDataTables instead of LeadDataTable
    if (customActiveTab === "5") {
        return (
            <TabPane tabId={tabId}>
                <div className="flex-grow-1 ms-2">
                    <div className="sn-lead-report-management-tble-ui">
                        <CommanDataTables
                            isLoading={isLoading}
                            column={columns}
                            tableData={data}
                        />
                    </div>
                </div>
            </TabPane>
        );
    }

    return (
        <TabPane tabId={tabId}>
            <div className="flex-grow-1 ms-2">
                <div className="sn-lead-report-management-tble-ui sn-table-height-Common">
                    <LeadDataTable
                        columns={columns}
                        data={data}
                        paginationTotalRows={totalRows}
                        progressPending={isLoading}
                        onChangePage={(page) => onPageChange(page, tabId)} // ✅ Pass tabId properly
                        onChangeRowsPerPage={(newPerPage) => onPerRowsChange(tabId, newPerPage)} // ✅ Ensure per-page updates correctly
                    />
                </div>
            </div>
        </TabPane>
    );

}

const getColumnsByTab = (tabId) => {

    // Lead overview table column 
    const OverviewColumns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },
        {
            name: <span className="font-weight-bold fs-13">Employee Name</span>,
            selector: (row) => row.fullName,
            cell: (row) => (
                <div className={`d-flex align-items-center`}>
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle-textImage"
                            style={{ background: getBackgroundColor(row?.fullName) }}
                        >
                            {row?.fullName ? row?.fullName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}
                    <div>
                        <span className="font-weight-medium">{row?.fullName || "Unknown"}</span>
                        <div className="text-muted font-weight-bold fs-13 mt-1">
                            ({row?.countryCode}) {row.mobileNumber || "N/A"}
                        </div>
                    </div>
                </div>
            ),
            sortable: true,
        },
        // {
        //     name: "Email",
        //     selector: (row) => row.email,    
        //     cell: (row) => <span>{row.email || "N/A"}</span>,
        //     sortable: true,
        //     key: "email",
        // },

        // {
        //     name: <span className="font-weight-bold fs-13">Role Name</span>,
        //     selector: (row) => row.role,
        //     cell: (row) =>
        //     (
        //         <div style={{ whiteSpace: "pre-line", textAlign: "left" }}>
        //             {row?.role && row.role.length > 0 ? row?.role?.map((roleItem, index) => (
        //                 <React.Fragment key={index}>
        //                     <span>
        //                         {roleItem}&nbsp;
        //                         {index !== row.role.length - 1 && <>, </>}
        //                     </span>
        //                 </React.Fragment>
        //             )) : (
        //                 <span>-</span>
        //             )}
        //         </div>
        //     ),
        //     sortable: true,
        // },

        // {
        //     name: <span className="font-weight-bold fs-13">Team</span>,
        //     selector: (row) => row.team,
        //     cell: (row) => (
        //         <div className="mt-2 mb-2">
        //             {row?.team && row.team.length > 0 ? (
        //                 row.team.map((callTeam, index) => (
        //                     <React.Fragment key={index}>
        //                         <span style={{ textTransform: "capitalize", textAlign: "left", float: "left" }}>
        //                             {callTeam}
        //                         </span>
        //                         <br />
        //                         {index !== row.team.length - 1 && <br />}
        //                     </React.Fragment>
        //                 ))
        //             ) : (
        //                 <span>-</span>
        //             )}
        //         </div>
        //     ),
        //     sortable: true,
        // },

        {
            name: "Assigned Leads",
            selector: (row) => row.numberOfLeads,
            cell: (row) => <span>{row.numberOfLeads || "0"}</span>,
            sortable: true,
            key: "numberOfLeads",
        },
        {
            name: "Contacted Leads",
            selector: (row) => row.contacted,
            cell: (row) => <span>{row.contacted || "0"}</span>,
            sortable: true,
            key: "contacted",
        },
        {
            name: "Not Contacted Leads",
            selector: (row) => row.notContacted,
            cell: (row) => <span>{row.notContacted || "0"}</span>,
            sortable: true,
            key: "notContacted",
        },


        // {
        //     name: "Created Date",
        //     selector: (row) => row.createdAt,
        //     cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
        //     sortable: true,
        //     key: "createdAt",
        // },

        // {
        //     name: "Lead Status",
        //     selector: (row) => row.status,
        //     cell: (row) => <span>{row.status || "-"}</span>,
        //     sortable: true,
        //     key: "status",
        // },

    ];


    // Lead Analytics table column 
    // const LeadAnalyticsColumns = [
    //     {
    //         name: "SN.",
    //         selector: (row, index) => index + 1,
    //         width: "55px",
    //     },
    //     {
    //         name: "Lead Created Date",
    //         selector: (row) => row.createdAt,
    //         cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
    //         sortable: true,
    //         key: "createdAt",
    //     },


    //     {
    //         name: <span className="font-weight-bold fs-13">Lead Name</span>,
    //         selector: (row) => row.firstName,
    //         cell: (row) => (
    //             <Link
    //                 to={`/lead-details`}
    //                 className="text-primary text-decoration-none"
    //             >
    //                 <div className={`d-flex align-items-center`}>
    //                     {row.profileImageUrl ? (
    //                         <img
    //                             src={row.profileImageUrl}
    //                             alt="Profile"
    //                             style={{
    //                                 width: "35px",
    //                                 height: "35px",
    //                                 objectFit: "cover",
    //                                 borderRadius: "50%",
    //                                 marginRight: "10px",
    //                             }}
    //                         />
    //                     ) : (
    //                         <div
    //                             className="rounded-circle d-flex justify-content-center align-items-center"
    //                             style={{
    //                                 width: "35px",
    //                                 height: "35px",
    //                                 background: getBackgroundColor(row?.firstName),
    //                                 marginRight: "10px",
    //                                 fontWeight: "bold",
    //                                 color: "#fff",
    //                             }}
    //                         >
    //                             {row.firstName ? row?.firstName?.charAt(0).toUpperCase() : "?"}
    //                         </div>
    //                     )}

    //                     <div>
    //                         <span className="font-weight-medium">{row?.firstName}  {row.lastName}</span>
    //                         <div className="text-muted font-weight-bold fs-13 mt-1">
    //                             <span>({row?.countryCode}) {row.phone || "N/A"}</span>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </Link>

    //         ),
    //         sortable: true,
    //     },


    //     // {
    //     //   name: "Email",
    //     //   selector: (row) => row.email,
    //     //   cell: (row) => <span>{row.email || "N/A"}</span>,
    //     //   sortable: true,
    //     //   key: "email",
    //     // },


    //     // {
    //     //     name: "Lead Number",
    //     //     selector: (row) => row.phone,
    //     //     cell: (row) => <span>({row?.countryCode}) {row.phone || "N/A"}</span>,
    //     //     sortable: true,
    //     //     key: "phone",
    //     // },

    //     // {
    //     //   name: "Alt.Phone Number",
    //     //   selector: (row) => row.alternatePhoneNumber,
    //     //   cell: (row) => <span>{row.alternatePhoneNumber || "N/A"}</span>,
    //     //   sortable: true,
    //     //   key: "phone",
    //     // },


    //     // {
    //     //   name: <span className="font-weight-bold fs-13">Role Name</span>,
    //     //   selector: (row) => row.role,
    //     //   cell: (row) =>
    //     //     (
    //     //       <div style={{ whiteSpace: "pre-line", textAlign: "left" }}>
    //     //         {row?.role?.map((roleItem, index) => (
    //     //           <React.Fragment key={index}>
    //     //             <span>
    //     //               {roleItem}&nbsp;
    //     //               {index !== row.role.length - 1 && <>, </>}
    //     //             </span>
    //     //           </React.Fragment>
    //     //         ))}
    //     //       </div>
    //     //     ) || "-",
    //     //   sortable: true,
    //     // },

    //     // {
    //     //   name: <span className="font-weight-bold fs-13">Team</span>,
    //     //   selector: (row) => row.team,
    //     //   cell: (row) => (
    //     //     <div className="mt-2 mb-2">
    //     //       {row?.team && row.team.length > 0 ? (
    //     //         row.team.map((callTeam, index) => (
    //     //           <React.Fragment key={index}>
    //     //             <span style={{ textTransform: "capitalize", textAlign: "left", float: "left" }}>
    //     //               {callTeam}
    //     //             </span>
    //     //             <br />
    //     //             {index !== row.team.length - 1 && <br />}
    //     //           </React.Fragment>
    //     //         ))
    //     //       ) : (
    //     //         <span>-</span>
    //     //       )}
    //     //     </div>
    //     //   ),
    //     //   sortable: true,
    //     // },

    //     {
    //         name: "Total Calls (Incoming + Outgoing)",
    //         selector: (row) => row.callLogAnalysis.totalCalls,
    //         cell: (row) => <span>{row.callLogAnalysis.totalCalls || "0"}</span>,
    //         sortable: true,
    //         key: "callLogAnalysistotalCalls",
    //     },


    //     {
    //         name: "Total Duration",
    //         selector: (row) => row.callLogAnalysis.totalDuration,
    //         cell: (row) => <span>{row.callLogAnalysis.totalDuration || "0"}</span>,
    //         sortable: true,
    //         key: "total duration",
    //     },


    //     {
    //         name: "Outgoing",
    //         selector: (row) => row.callLogAnalysis.totalOutgoing,
    //         cell: (row) => <span>{row.callLogAnalysis.totalOutgoing || "0"}</span>,
    //         sortable: true,
    //         key: "outgoing",
    //     },

    //     {
    //         name: "Incoming",
    //         selector: (row) => row.callLogAnalysis.totalIncoming,
    //         cell: (row) => <span>{row.callLogAnalysis.totalIncoming || "0"}</span>,
    //         sortable: true,
    //         key: "incoming",
    //     },
    //     {
    //         name: "Not Pickup by Client",
    //         selector: (row) => row.callLogAnalysis.notPickedUpByClient,
    //         cell: (row) => <span>{row.callLogAnalysis.notPickedUpByClient || "0"}</span>,
    //         sortable: true,
    //         key: "notPickedUpByClient",
    //     },

    //     // {
    //     //   name: "Created Date",
    //     //   selector: (row) => row.createdAt,
    //     //   cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
    //     //   sortable: true,
    //     //   key: "createdAt",
    //     // },

    //     {
    //         name: "Current Status",
    //         selector: (row) => row.status,
    //         cell: (row) => <span>{row.status || "-"}</span>,
    //         sortable: true,
    //         key: "status",
    //     },

    // ];
    const LeadAnalyticsColumns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },
        {
            name: <span className="text-wrap">Lead Created Date</span>,
            selector: (row) => row.createdAt,
            cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
            sortable: true,
            key: "createdAt",
        },

        {
            name: <span className="font-weight-bold fs-13 text-wrap">Lead Name</span>,
            selector: (row) => row.firstName,
            minWidth: "220px",
            cell: (row) => (
                <a
                href={`/lead-details`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-none d-flex align-items-center"
                style={{ gap: "10px", whiteSpace: "nowrap" }}
                    onClick={() => {
                        localStorage.removeItem("leadId"); 
                        localStorage.setItem("leadId", row._id); 
                    }}
                >
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                border: "2px solid #ddd",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "30px",
                                height: "30px",
                                background: getBackgroundColor(row?.firstName),
                                fontWeight: "bold",
                                color: "#fff",
                                fontSize: "15px",
                            }}
                        >
                            {row.firstName ? row.firstName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}

                    <div className="d-flex flex-column text-break">  
                        <span className="font-weight-medium fs-14">{row?.firstName} {row.lastName}</span>
                        <span className="text-muted font-weight-bold fs-12 mt-0">
                            ({row?.countryCode}) {row.phone || "N/A"}
                        </span>
                    </div>
                </a>
            ),
        },

        {
            name: <span className="text-wrap">Total Calls (Incoming+Outgoing)</span>,
            selector: (row) => row.callLogAnalysis.totalCalls,
            cell: (row) => <span>{row.callLogAnalysis.totalCalls || "0"}</span>,
            sortable: true,
            key: "callLogAnalysistotalCalls",
            width:"150px",
        },

        {
            name: <span className="text-wrap">Total Duration</span>,
            selector: (row) => row.callLogAnalysis.totalDuration,
            cell: (row) => <span className="text-center align-middle">{row.callLogAnalysis.totalDuration || "0"}</span>,
            sortable: true,
            key: "total duration",
        },

        {
            name: <span className="text-wrap">Outgoing</span>,
            selector: (row) => row.callLogAnalysis.totalOutgoing,
            cell: (row) => <span className="text-center align-middle">{row.callLogAnalysis.totalOutgoing || "0"}</span>,
            sortable: true,
            key: "outgoing",
        },

        {
            name: <span className="text-wrap">Incoming</span>,
            selector: (row) => row.callLogAnalysis.totalIncoming,
            cell: (row) => <span>{row.callLogAnalysis.totalIncoming || "0"}</span>,
            sortable: true,
            key: "incoming",
        },
        {
            name: <span className="text-wrap">Not Pickup by Client</span>,
            selector: (row) => row.callLogAnalysis.notPickedUpByClient,
            cell: (row) => <span>{row.callLogAnalysis.notPickedUpByClient || "0"}</span>,
            sortable: true,
            key: "notPickedUpByClient",
        },

        {
            name: <span className="text-wrap">Current Status</span>,
            selector: (row) => row.status,
            cell: (row) => <span>{row.status || "-"}</span>,
            sortable: true,
            key: "status",
        },
    ];

    // Employee Analytics table column 
    const EmployeeAnalyticsColumns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },

        {
            name: "Employee Name",
            selector: (row) => row.fullName,
            cell: (row) => (
                <div className="d-flex align-items-center">
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row.fullName),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.fullName ? row.fullName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}
                    <span>{row.fullName || "Unknown"}</span>
                </div>
            ),
            sortable: true,
            key: "fullName",
        },

        {
            name: "Total Duration",
            selector: (row) => row.callDetails.duration || '-',
            cell: (row) => <span>{formatDuration(row.callDetails.duration)}</span>,
            sortable: true,
            key: "callLogAnalysistotalCalls",
        },

        {
            name: "Outgoing",
            selector: (row) => row.callDetails.outgoing,
            cell: (row) => <span>{row.callDetails.outgoing || "0"}</span>,
            sortable: true,
            key: "outgoing",
        },

        {
            name: "Incoming",
            selector: (row) => row.callDetails.incoming,
            cell: (row) => <span>{row.callDetails.incoming || "0"}</span>,
            sortable: true,
            key: "incoming",
        },

        {
            name: "Not Pickup by Client",
            selector: (row) => row.callDetails.notPickedUpByClient,
            cell: (row) => <span>{row.callDetails.notPickedUpByClient || "0"}</span>,
            sortable: true,
            key: "notPickedUpByClient",
        },

    ];


    // Lead Call History table column 
    const LeadCallHistoryColumns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },
        {
            name: <span className="font-weight-bold fs-13">Employee Name</span>,
            selector: (row) => row.employeeDesription[0].fullName || '-',
            cell: (row) => (

                <div className={`d-flex align-items-center`}>
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl || ''}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row.employeeDesription[0].fullName || '-'),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.employeeDesription[0]?.fullName ? row.employeeDesription[0]?.fullName.charAt(0).toUpperCase() : "-"}
                        </div>
                    )}
                    <div>
                        <span className="font-weight-medium">{row.employeeDesription[0]?.fullName || "-"}</span>
                        <div className="text-muted font-weight-bold fs-13 mt-1">
                            ({row?.employeeDesription[0]?.countryCode}) {row?.employeeDesription[0]?.mobileNumber || "N/A"}
                        </div>
                    </div>
                </div>
            ),
            sortable: true,
        },
        {
            name: "Lead Name",
            selector: (row) => row?.lead.firstName || '-',
            cell: (row) => (
                <>
                    <div className="mt-2 mb-2">
                        <h5
                            className="font-weight-bold fs-13"
                            style={{ textTransform: "capitalize" }}
                        >
                            {row?.lead?.firstName || ''}    {row?.lead?.lastName || ''}
                        </h5>
                        <h6 className="text-center- font-weight-bold fs-13">
                            {row?.lead?.phone || '-'}
                        </h6>
                    </div>

                </>
            ),
            sortable: true,
            key: "leadname",
        },


        {
            name: "Date / Time",
            selector: (row) => row.createdAt || '-',
            cell: (row) => <span>{moment(row.createdAt).format("DD MMM YYYY")}   {formatToSystemTimezone(row.createdAt) || '-'}</span>,
            sortable: true,
            key: "createdAt",
        },

        {
            name: "Duration",
            selector: (row) => row.duration || '',
            cell: (row) => <span>{formatDuration(row.duration) || "N/A"}</span>,
            sortable: true,
            key: "duration",
        },

        {
            name: "Call Type",
            selector: (row) => row?.type || '-',
            cell: (row) => <span>{row?.type || "N/A"}</span>,
            sortable: true,
            key: "type",
        },


        {
            name: "Lead Created Date",
            selector: (row) => row.lead.createdAt || '-',
            cell: (row) => <span>{moment(row?.lead?.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
            sortable: true,
            key: "createdAt",
        },

        {
            name: "Lead Status",
            selector: (row) => row?.lead?.status || '-',
            cell: (row) => <span>{row?.lead?.status || "-"}</span>,
            sortable: true,
            key: "status",
        },
        {
            name: "Notes",
            selector: (row) => row.note || '-',
            cell: (row) => <span>{row.note || "-"}</span>,
            sortable: true,
            key: "note",
        },

    ];


    const LeadNeverAttended = [
        {
            name: <span className="font-weight-bold fs-13">S No.</span>,
            selector: (row, index) => index + 1,
            sortable: false,
            width: "80px",
        },
        {
            name: <span className="font-weight-bold fs-13">Employee Name</span>,
            selector: (row) => row.empDescription[0].fullName,
            cell: (row) => (
                <div className={`d-flex align-items-center`}>
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl || ''}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row.empDescription[0].fullName || '-'),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.empDescription[0]?.fullName ? row.empDescription[0]?.fullName.charAt(0).toUpperCase() : "-"}
                        </div>
                    )}
                    <div>
                        <span className="font-weight-medium">{row.empDescription[0]?.fullName || "-"}</span>
                        <div className="text-muted font-weight-bold fs-13 mt-1">
                            ({row?.empDescription[0]?.countryCode}) {row?.empDescription[0]?.mobileNumber || "N/A"}
                        </div>
                    </div>
                </div>
            ),

            sortable: true,
            width: "200px",
        },


        {
            name: "Lead Name",
            selector: (row) => row?.leadDetail.firstName || '-',
            cell: (row) => (
                <>
                    <div className="mt-2 mb-2">
                        <h5
                            className="font-weight-bold fs-13"
                            style={{ textTransform: "capitalize" }}
                        >
                            {row?.leadDetail?.firstName || ''}    {row?.leadDetail?.lastName || ''}
                        </h5>
                        <h6 className="text-center- font-weight-bold fs-13">
                            ({row?.leadDetail?.countryCode}) {row?.leadDetail?.phone || '-'}
                        </h6>
                    </div>

                </>
            ),
            sortable: true,
            key: "leadname",
        },

        {
            name: <span className="font-weight-bold fs-13 fs-2">Date</span>,
            selector: (row) => row?.date,
            cell: (row) => (
                <div className="timeSet">
                    {row?.dataAndType?.map((callDate, index) => (
                        <React.Fragment key={index}>
                            <span>{moment(callDate.date).format("DD MMM YYYY")}</span>
                            <br />
                            {index !== row.dataAndType.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13 fs-2">Time</span>,
            selector: (row) => (
                <div className="timeSet">
                    {row?.dataAndType?.map((callTime, index) => {
                        const momentObj = moment(callTime.date).format("hh:mm A");
                        return (
                            <React.Fragment key={index}>
                                <span className="gap-2">{momentObj}</span>
                                <br />
                                {index !== row?.dataAndType?.length - 1 && <br />}
                            </React.Fragment>
                        );
                    })}
                </div>
            ),
            // sortable: true
        },

        {
            name: <span className="font-weight-bold fs-13 fs-2">Call Type</span>,
            selector: (row) => (
                <div className="timeSet">
                    {row?.dataAndType.map((callType, index) => {
                        let content;
                        switch (callType.type) {
                            case "OUTGOING":
                                content = (
                                    <>
                                        <div className="sn-call-type-newer-call">
                                            <i className="mdi mdi-phone-outgoing sn-out-going-text" />
                                            <span className="badge badge-soft-info sn-out-going-call">
                                                {callType.type}
                                            </span>
                                        </div>
                                    </>
                                );
                                break;
                            case "MISSED":
                                content = (
                                    <>
                                        <div className="sn-call-type-newer-call">
                                            <i className="mdi mdi-phone-missed sn-out-missed-text sn-never-attended-icon-mm" />
                                            <span className="gap-2 sn-out-missed-call">
                                                {callType.type}
                                            </span>
                                        </div>
                                    </>
                                );
                                break;
                            case "REJECTED":
                                content = (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontSize: "medium",
                                            fontWeight: "bold",
                                            color: "#e97dfb",
                                        }}
                                    >
                                        <div className="sn-call-type-newer-call">
                                            <i className="ri-indeterminate-circle-line rejected-icon-never" />
                                            <span
                                                className="gap-2 sn-out-missed-call"
                                                style={{
                                                    color: "#e97dfb",
                                                    background: "rgb(233 125 251 / 10%)",
                                                }}
                                            >
                                                {callType.type}
                                            </span>
                                        </div>
                                    </div>
                                );
                                break;
                            default:
                                content = null; // No content for other types
                        }

                        return (
                            <React.Fragment key={index}>
                                {content}
                                {index !== row.dataAndType.length - 1 && <br />}
                            </React.Fragment>
                        );
                    })
                    }
                </div>
            ),
        },

        {
            name: <span className="font-weight-bold fs-13">Attempt to Call</span>,
            selector: (row) => {
                return (
                    <>
                        <h5
                            className="font-weight-bold fs-13"
                            style={{
                                textTransform: "capitalize",
                                color: "blue",
                                fontWeight: "900",
                            }}
                        >
                            <span
                                style={{
                                    color: row.attempt > 0 ? "inherit" : "red",
                                    cursor: "inherit",
                                }}
                            >
                                {row.attempt > 0 ? `${row.attempt} Times` : "Not Attempted"}
                            </span>
                        </h5>
                    </>
                );
            },
            sortable: true,
        },
    ];

    // Never Pickup  table column 
    const LeadNeverPickupColumns = [
        {
            name: "SN.",
            selector: (row, index) => index + 1,
            width: "55px",
        },
        {
            name: <span className="font-weight-bold fs-13">Employee Name</span>,
            selector: (row) => row.employeeDesription[0].fullName | '',
            cell: (row) => (
                <div className={`d-flex align-items-center`}>
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl || ''}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row?.employeeDesription[0].fullName || '-'),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.employeeDesription[0]?.fullName ? row.employeeDesription[0]?.fullName.charAt(0).toUpperCase() : "-"}
                        </div>
                    )}
                    <div>
                        <span className="font-weight-medium">{row.employeeDesription[0]?.fullName || "-"}</span>
                        <div className="text-muted font-weight-bold fs-13 mt-1">
                            ({row?.employeeDesription[0]?.countryCode | ''}) {row?.employeeDesription[0]?.mobileNumber || "N/A"}
                        </div>
                    </div>
                </div>
            ),
            sortable: true,
        },

        {
            name: "Lead Name",
            selector: (row) => row?.lead.firstName || '-',
            cell: (row) => (
                <>
                    <div className="mt-2 mb-2">
                        <h5
                            className="font-weight-bold fs-13"
                            style={{ textTransform: "capitalize" }}
                        >
                            {row?.lead?.firstName || ''}    {row?.lead?.lastName || ''}
                        </h5>
                        <h6 className="text-center- font-weight-bold fs-13">
                            {row?.lead?.phone || '-'}
                        </h6>
                    </div>

                </>
            ),
            sortable: true,
            key: "leadname",
        },

        {
            name: "Call Type",
            selector: (row) => row.type || '-',
            cell: (row) => <span>{row.type || "N/A"}</span>,
            sortable: true,
            key: "type",
        },


        {
            name: "Date / Time",
            selector: (row) => row.createdAt || '',
            cell: (row) => <span>{moment(row.createdAt).format("DD MMM YYYY")}   {formatToSystemTimezone(row.createdAt) || ''}</span>,
            sortable: true,
            key: "createdAt",
        },

    ];


    const columnMappings = {
        "1": OverviewColumns,
        "2": LeadAnalyticsColumns,
        "3": EmployeeAnalyticsColumns,
        "4": LeadCallHistoryColumns,
        "5": LeadNeverAttended,
        "6": LeadNeverPickupColumns,
    };

    return columnMappings[tabId] || [];
};

export { ReportTabPane, getColumnsByTab }